"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeFetchableTransform = exports.IkeFetchableOne = exports.IkeFetchableMany = exports.IkeFetchableBase = exports.IkeFetchableStore = void 0;
exports.lastFetchObjectOrNow = lastFetchObjectOrNow;
var tslib_1 = require("tslib");
var array_1 = require("../util/array");
var IkeFetchableStore = /** @class */ (function () {
    function IkeFetchableStore() {
    }
    IkeFetchableStore.prototype.setIsFetching = function (isFetching) {
        this.isFetching = isFetching;
    };
    IkeFetchableStore.prototype.setValue = function (value, lastFetch) {
        this.value = value;
        this.lastFetch = lastFetch;
        this.isFetching = false;
    };
    IkeFetchableStore.prototype.setError = function (error) {
        this.error = error;
        this.isFetching = false;
    };
    return IkeFetchableStore;
}());
exports.IkeFetchableStore = IkeFetchableStore;
var IkeFetchableBase = /** @class */ (function () {
    function IkeFetchableBase(store, query) {
        this.query = query;
        this.store = store;
    }
    Object.defineProperty(IkeFetchableBase.prototype, "hasFetched", {
        get: function () {
            return this.store.lastFetch != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkeFetchableBase.prototype, "isFetching", {
        get: function () {
            return this.store.isFetching;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkeFetchableBase.prototype, "lastFetch", {
        get: function () {
            return this.store.lastFetch;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkeFetchableBase.prototype, "error", {
        get: function () {
            return this.store.error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkeFetchableBase.prototype, "value", {
        /**
         * @deprecated Using this getter can create race conditions because it calls `fetch` without awaiting. Use `fetch()` directly instead.
         */
        get: function () {
            if (this.hasFetched) {
                if (this.store.error) {
                    return null;
                }
                return this.store.value;
            }
            if (!this.isFetching) {
                this.fetch();
            }
            return this.store.value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Re-query the fetchable
     */
    IkeFetchableBase.prototype.refetch = function () {
        this.store.promise = null;
        return this.fetch();
    };
    /**
     * Clear the fetchable value.
     * The fetchable will be re-queried next time it is used.
     */
    IkeFetchableBase.prototype.reset = function () {
        this.store.promise = null;
        this.store.setValue(null, null);
    };
    IkeFetchableBase.prototype.fetch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.store.promise != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.store.promise];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.store.promise = this.query()
                            .then(function (obj) {
                            _this.init(obj);
                            return obj;
                        })
                            .catch(function (e) {
                            _this.store.setError(e);
                            throw e;
                        });
                        this.store.setIsFetching(true);
                        return [4 /*yield*/, this.store.promise];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return IkeFetchableBase;
}());
exports.IkeFetchableBase = IkeFetchableBase;
var IkeFetchableMany = /** @class */ (function (_super) {
    tslib_1.__extends(IkeFetchableMany, _super);
    function IkeFetchableMany() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mapByKey = {};
        return _this;
    }
    Object.defineProperty(IkeFetchableMany.prototype, "first", {
        get: function () {
            var value = this.value;
            if (value != null) {
                return value[0];
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    IkeFetchableMany.prototype.find = function (key, value) {
        if (this.value == null) {
            return null;
        }
        if (typeof value !== 'string') {
            throw new Error("Unable to lookup by value which is not a string typeof:".concat(typeof value));
        }
        var map = this.mapByKey[key];
        if (map == null) {
            map = this.mapByKey[key] = array_1.IkeArray.toMap(this.value, key);
        }
        // TODO is there a better way to fix this
        return map[value];
    };
    /**
     * Set a initial value for this fetchable,
     * Last fetch time will use the updatedAt of the objector
     * the current time depending on which is newer.
     */
    IkeFetchableMany.prototype.init = function (value) {
        this.mapByKey = {};
        this.store.setValue(value, this.lastUpdatedAt(value));
        this.store.promise = Promise.resolve(this.store.value);
        this.store.setError(null);
    };
    IkeFetchableMany.prototype.lastUpdatedAt = function (value) {
        if (value == null || value.length === 0) {
            return Date.now();
        }
        var lastObj = null;
        for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
            var v = value_1[_i];
            if (lastObj == null || lastObj.updatedAt < v.updatedAt) {
                lastObj = v;
            }
        }
        return lastFetchObjectOrNow(lastObj);
    };
    return IkeFetchableMany;
}(IkeFetchableBase));
exports.IkeFetchableMany = IkeFetchableMany;
/**
 * Last fetch should be set to the current time,
 * but sometimes user's clocks are off, so use the server time if that
 * is ahead other wise use the user's time
  */
function lastFetchObjectOrNow(obj) {
    var currentTime = Date.now();
    if (obj == null || obj.updatedAt == null) {
        return currentTime;
    }
    var updatedAt = new Date(obj.updatedAt).getTime();
    var timeDiff = updatedAt - currentTime;
    if (timeDiff > 0) {
        return updatedAt;
    }
    return currentTime;
}
var IkeFetchableOne = /** @class */ (function (_super) {
    tslib_1.__extends(IkeFetchableOne, _super);
    function IkeFetchableOne() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Set a initial value for this fetchable
     * Last fetch time will use the updatedAt of the object or
     * the current time depending on which is newer.
     */
    IkeFetchableOne.prototype.init = function (value) {
        this.store.setValue(value, lastFetchObjectOrNow(value));
        this.store.promise = Promise.resolve(this.store.value);
        this.store.setError(null);
    };
    return IkeFetchableOne;
}(IkeFetchableBase));
exports.IkeFetchableOne = IkeFetchableOne;
var IkeFetchableTransform = /** @class */ (function (_super) {
    tslib_1.__extends(IkeFetchableTransform, _super);
    function IkeFetchableTransform(store, base, transform) {
        var _this = _super.call(this, store, function () { return base.fetch().then(function (obj) { return _this.transform(obj); }); }) || this;
        _this.base = base;
        _this.transform = transform;
        return _this;
    }
    IkeFetchableTransform.prototype.init = function (value) {
        this.store.setValue(value, Date.now());
        this.store.promise = Promise.resolve(this.store.value);
        this.store.setError(null);
    };
    return IkeFetchableTransform;
}(IkeFetchableBase));
exports.IkeFetchableTransform = IkeFetchableTransform;
//# sourceMappingURL=fetchable.js.map